import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Content, ListItem, CheckBox, Text, Body, View } from 'react-native';
import { Content, ListItem, CheckBox, Text, Body, View } from 'native-base';
import ComponentRouter from './ComponentRouter';

class BlockCheckbox extends Component {
  state = {
    visible: false
  }

  handlerChange = (newValue, element) => {
    let { block, onChange, value } = this.props;

    if (!(value && Array.isArray(value))) {
      value = [];
    }

    if (value.includes(newValue)) {
      value = value.filter(v => v !== newValue);
    } else {
      value.push(newValue);
    }

    if (element.blocks && element.blocks.length) {
      this.setState({ visible: !this.state.visible });
    }

    onChange && onChange({
      block,
      element,
      value
    });
  }

  render() {
    const { block, value } = this.props;
    const { visible } = this.state;

    return (
      <Content>
        {block.elements.map((element, i) => {
          return <View key={i}>
            <ListItem
              style={{ marginLeft: 2 }}
              onPress={() => this.handlerChange(element.value, element)} >
              <CheckBox
                color='#D30000'
                checked={value.includes(element.value)}
                onPress={() => this.handlerChange(element.value, element)}
              />
              <Body>
                <Text>{element.label}</Text>
              </Body>
            </ListItem>
            {/* {element.blocks && element.blocks.length ? <View style={{ display:'block'}}> */}
            {/* {element.blocks && element.blocks.length ? <View style={ visible && { display: 'block' }}> */}

            {element.blocks && element.blocks.length ?
             <View 
            //  style={{ display: visible ? 'block' : 'none' }}
             >

              {element.blocks.map((block, i) => {
                return <ComponentRouter key={i} block={block} />;
              })}
            </View> : null}

          </View>;
        })}
      </Content>
    );
  }
}

BlockCheckbox.propTypes = {
  block: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.any
};

export default BlockCheckbox;
